import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '../../lib/cn';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      data-slot="input"
      className={cn(
        'flex h-10 w-full rounded-md border border-line-control bg-input px-3 py-2 text-sm text-text',
        'placeholder:text-muted transition-colors focus-visible:border-accent focus-visible:bg-panel',
        'focus-visible:outline-2 focus-visible:outline-ring focus-visible:outline-offset-1',
        'disabled:opacity-60',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
